import { Row, Col, Card, Typography, Divider } from 'antd';
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { db, doc, getDoc } from '../firebase';
import QRCode from "react-qr-code";

const { Title, Text } = Typography;

/**
 * Public member card — reads ONLY public_member_profiles (safe fields).
 * Full members/{id} docs are locked to owner/staff after security hardening.
 */
const UserProfile = () => {
  const { userId } = useParams();
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      if (!userId) return;

      // Prefer public mirror (no email/phone/address)
      const publicRef = doc(db, "public_member_profiles", userId);
      const publicSnap = await getDoc(publicRef);
      if (publicSnap.exists()) {
        setUserData(publicSnap.data());
        return;
      }

      // Fallback for owners viewing their own profile before mirror exists
      try {
        const memberRef = doc(db, "members", userId);
        const memberSnap = await getDoc(memberRef);
        if (memberSnap.exists()) {
          const d = memberSnap.data();
          setUserData({
            first_name: d.first_name,
            last_name: d.last_name,
            middle_name: d.middle_name,
            pew: d.pew,
            office: d.office,
            officer_at: d.officer_at,
            profile_image: d.profile_image,
          });
        } else {
          console.log("No such document!");
        }
      } catch (err) {
        console.warn("Member profile unavailable (expected for other users):", err?.message);
      }
    };

    fetchUserData();
  }, [userId]);

  return (
    <div className="bg-gray-100 pt-48 p-6 min-h-screen">
      <Row gutter={[16, 16]} justify="center" align="top">
        <Col xs={24} sm={24} md={12} lg={8}>
          <Card className="shadow-lg p-6 rounded-lg bg-white">
            <div className="flex justify-center">
              <img
                src={userData?.profile_image || "https://via.placeholder.com/150"}
                alt={userData?.first_name || "User profile"}
                className="mb-4 w-[120px] h-[120px] rounded-full"
              />
            </div>
            <Title level={3} className="text-center text-xl font-semibold">
              {userData?.first_name && userData?.last_name
                ? `${userData.first_name} ${userData.last_name}`
                : "Not Added"}
            </Title>
            <Text className="block text-center text-lg text-gray-600">
              {userData
                ? `${userData.pew || "Not Added"}${userData.office ? ` | Office: ${userData.office}` : ""}${userData.officer_at ? ` | At ${userData.officer_at}` : ""}`
                : "Not Added"}
            </Text>

            <Divider />

            <div className="flex justify-center mt-6">
              <QRCode
                value={`https://ooobcs.org/profile/${userId}`}
                size={128}
              />
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default UserProfile;
